// This file is auto-generated by @hey-api/openapi-ts

import { client } from './client.gen.js';
import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client/index.js';
import type { DocumentsServiceCreateDocumentLinkData, DocumentsServiceCreateDocumentLinkErrors, DocumentsServiceCreateDocumentLinkResponses, DocumentsServiceDeleteDocumentData, DocumentsServiceDeleteDocumentErrors, DocumentsServiceDeleteDocumentLinkData, DocumentsServiceDeleteDocumentLinkErrors, DocumentsServiceDeleteDocumentLinkResponses, DocumentsServiceDeleteDocumentResponses, DocumentsServiceDownloadDocumentData, DocumentsServiceDownloadDocumentErrors, DocumentsServiceDownloadDocumentResponses, DocumentsServiceGetDocumentLinkData, DocumentsServiceGetDocumentLinkErrors, DocumentsServiceGetDocumentLinkResponses, DocumentsServiceGetDocumentLinksData, DocumentsServiceGetDocumentLinksErrors, DocumentsServiceGetDocumentLinksResponses, DocumentsServiceGetDocumentMetadataData, DocumentsServiceGetDocumentMetadataErrors, DocumentsServiceGetDocumentMetadataResponses, DocumentsServiceGetDocumentsData, DocumentsServiceGetDocumentsErrors, DocumentsServiceGetDocumentsResponses, DocumentsServiceUpdateDocumentLinkData, DocumentsServiceUpdateDocumentLinkErrors, DocumentsServiceUpdateDocumentLinkResponses, DocumentsServiceUploadDocumentData, DocumentsServiceUploadDocumentErrors, DocumentsServiceUploadDocumentResponses, PartnersServiceCreatePartnerData, PartnersServiceCreatePartnerErrors, PartnersServiceCreatePartnerResponses, PartnersServiceGetPartnerData, PartnersServiceGetPartnerErrors, PartnersServiceGetPartnerResponses, PartnersServiceGetPartnersData, PartnersServiceGetPartnersErrors, PartnersServiceGetPartnersResponses, PartnersServiceRemovePartnerData, PartnersServiceRemovePartnerErrors, PartnersServiceRemovePartnerResponses, PartnersServiceUpdatePartnerData, PartnersServiceUpdatePartnerErrors, PartnersServiceUpdatePartnerResponses, ReportsServiceGetCompPointsReportData, ReportsServiceGetCompPointsReportErrors, ReportsServiceGetCompPointsReportResponses, ReportsServiceGetShiftTotalsConfigData, ReportsServiceGetShiftTotalsConfigErrors, ReportsServiceGetShiftTotalsConfigResponses, ReportsServiceGetShiftTotalsReportData, ReportsServiceGetShiftTotalsReportErrors, ReportsServiceGetShiftTotalsReportResponses, ReportsServiceUpdateShiftTotalsConfigData, ReportsServiceUpdateShiftTotalsConfigErrors, ReportsServiceUpdateShiftTotalsConfigResponses, ScheduleConfigServiceApproveVacationRequestData, ScheduleConfigServiceApproveVacationRequestErrors, ScheduleConfigServiceApproveVacationRequestResponses, ScheduleConfigServiceCreateHolidayData, ScheduleConfigServiceCreateHolidayErrors, ScheduleConfigServiceCreateHolidayResponses, ScheduleConfigServiceCreateShiftData, ScheduleConfigServiceCreateShiftErrors, ScheduleConfigServiceCreateShiftResponses, ScheduleConfigServiceCreateVacationRequestData, ScheduleConfigServiceCreateVacationRequestResponses, ScheduleConfigServiceDeleteHolidayData, ScheduleConfigServiceDeleteHolidayErrors, ScheduleConfigServiceDeleteHolidayResponses, ScheduleConfigServiceDeleteShiftData, ScheduleConfigServiceDeleteShiftErrors, ScheduleConfigServiceDeleteShiftResponses, ScheduleConfigServiceDeleteVacationRequestData, ScheduleConfigServiceDeleteVacationRequestErrors, ScheduleConfigServiceDeleteVacationRequestResponses, ScheduleConfigServiceDenyVacationRequestData, ScheduleConfigServiceDenyVacationRequestErrors, ScheduleConfigServiceDenyVacationRequestResponses, ScheduleConfigServiceGetAllHolidaysData, ScheduleConfigServiceGetAllHolidaysErrors, ScheduleConfigServiceGetAllHolidaysResponses, ScheduleConfigServiceGetHolidaysData, ScheduleConfigServiceGetHolidaysErrors, ScheduleConfigServiceGetHolidayShiftsData, ScheduleConfigServiceGetHolidayShiftsErrors, ScheduleConfigServiceGetHolidayShiftsResponses, ScheduleConfigServiceGetHolidaysResponses, ScheduleConfigServiceGetShiftsData, ScheduleConfigServiceGetShiftsErrors, ScheduleConfigServiceGetShiftsResponses, ScheduleConfigServiceGetVacationRequestsByPartnerData, ScheduleConfigServiceGetVacationRequestsByPartnerResponses, ScheduleConfigServiceGetVacationRequestsData, ScheduleConfigServiceGetVacationRequestsResponses, ScheduleConfigServiceGetVacationTypesData, ScheduleConfigServiceGetVacationTypesResponses, ScheduleConfigServiceRerankShiftsData, ScheduleConfigServiceRerankShiftsErrors, ScheduleConfigServiceRerankShiftsResponses, ScheduleConfigServiceUpdateHolidayData, ScheduleConfigServiceUpdateHolidayErrors, ScheduleConfigServiceUpdateHolidayResponses, ScheduleConfigServiceUpdateHolidayShiftsData, ScheduleConfigServiceUpdateHolidayShiftsErrors, ScheduleConfigServiceUpdateHolidayShiftsResponses, ScheduleConfigServiceUpdateShiftData, ScheduleConfigServiceUpdateShiftErrors, ScheduleConfigServiceUpdateShiftResponses, ScheduleServiceCreateAssignmentData, ScheduleServiceCreateAssignmentErrors, ScheduleServiceCreateAssignmentResponses, ScheduleServiceCreateScheduleData, ScheduleServiceCreateScheduleErrors, ScheduleServiceCreateScheduleResponses, ScheduleServiceDownloadPartnerScheduleData, ScheduleServiceDownloadPartnerScheduleErrors, ScheduleServiceDownloadPartnerScheduleResponses, ScheduleServiceGetLimitedScheduleData, ScheduleServiceGetLimitedScheduleErrors, ScheduleServiceGetLimitedScheduleResponses, ScheduleServiceGetPartnerScheduleData, ScheduleServiceGetPartnerScheduleErrors, ScheduleServiceGetPartnerScheduleResponses, ScheduleServiceGetPublishDateData, ScheduleServiceGetPublishDateErrors, ScheduleServiceGetPublishDateResponses, ScheduleServiceGetScheduleData, ScheduleServiceGetScheduleErrors, ScheduleServiceGetScheduleResponses, ScheduleServicePublishScheduleData, ScheduleServicePublishScheduleErrors, ScheduleServicePublishScheduleResponses, ScheduleServiceUpdateScheduleAsWorkedData, ScheduleServiceUpdateScheduleAsWorkedErrors, ScheduleServiceUpdateScheduleAsWorkedResponses, ScheduleServiceUpdateUnpublishedScheduleData, ScheduleServiceUpdateUnpublishedScheduleErrors, ScheduleServiceUpdateUnpublishedScheduleResponses, UsersServiceCreateAllAccountsData, UsersServiceCreateAllAccountsErrors, UsersServiceCreateAllAccountsResponses, UsersServiceCreateUserData, UsersServiceCreateUserErrors, UsersServiceCreateUserResponses, UsersServiceDeleteUserData, UsersServiceDeleteUserErrors, UsersServiceDeleteUserResponses, UsersServiceGetPartnerData, UsersServiceGetPartnerErrors, UsersServiceGetPartnerResponses, UsersServiceGetUserData, UsersServiceGetUserErrors, UsersServiceGetUserResponses, UsersServiceGetUsersData, UsersServiceGetUsersErrors, UsersServiceGetUsersResponses, UsersServiceReinstateUserData, UsersServiceReinstateUserErrors, UsersServiceReinstateUserResponses, UsersServiceSetUserRoleData, UsersServiceSetUserRoleErrors, UsersServiceSetUserRoleResponses, UsersServiceUpdateUserData, UsersServiceUpdateUserErrors, UsersServiceUpdateUserResponses } from './types.gen.js';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class UsersService {
    public static usersServiceGetUsers<ThrowOnError extends boolean = true>(options?: Options<UsersServiceGetUsersData, ThrowOnError>): RequestResult<UsersServiceGetUsersResponses, UsersServiceGetUsersErrors, ThrowOnError> {
        return (options?.client ?? client).get<UsersServiceGetUsersResponses, UsersServiceGetUsersErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users',
            ...options
        });
    }
    
    public static usersServiceCreateUser<ThrowOnError extends boolean = true>(options: Options<UsersServiceCreateUserData, ThrowOnError>): RequestResult<UsersServiceCreateUserResponses, UsersServiceCreateUserErrors, ThrowOnError> {
        return (options.client ?? client).post<UsersServiceCreateUserResponses, UsersServiceCreateUserErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static usersServiceCreateAllAccounts<ThrowOnError extends boolean = true>(options?: Options<UsersServiceCreateAllAccountsData, ThrowOnError>): RequestResult<UsersServiceCreateAllAccountsResponses, UsersServiceCreateAllAccountsErrors, ThrowOnError> {
        return (options?.client ?? client).post<UsersServiceCreateAllAccountsResponses, UsersServiceCreateAllAccountsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/createAllPartners',
            ...options
        });
    }
    
    public static usersServiceDeleteUser<ThrowOnError extends boolean = true>(options: Options<UsersServiceDeleteUserData, ThrowOnError>): RequestResult<UsersServiceDeleteUserResponses, UsersServiceDeleteUserErrors, ThrowOnError> {
        return (options.client ?? client).delete<UsersServiceDeleteUserResponses, UsersServiceDeleteUserErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/{id}',
            ...options
        });
    }
    
    public static usersServiceGetUser<ThrowOnError extends boolean = true>(options: Options<UsersServiceGetUserData, ThrowOnError>): RequestResult<UsersServiceGetUserResponses, UsersServiceGetUserErrors, ThrowOnError> {
        return (options.client ?? client).get<UsersServiceGetUserResponses, UsersServiceGetUserErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/{id}',
            ...options
        });
    }
    
    public static usersServiceUpdateUser<ThrowOnError extends boolean = true>(options: Options<UsersServiceUpdateUserData, ThrowOnError>): RequestResult<UsersServiceUpdateUserResponses, UsersServiceUpdateUserErrors, ThrowOnError> {
        return (options.client ?? client).put<UsersServiceUpdateUserResponses, UsersServiceUpdateUserErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static usersServiceSetUserRole<ThrowOnError extends boolean = true>(options: Options<UsersServiceSetUserRoleData, ThrowOnError>): RequestResult<UsersServiceSetUserRoleResponses, UsersServiceSetUserRoleErrors, ThrowOnError> {
        return (options.client ?? client).put<UsersServiceSetUserRoleResponses, UsersServiceSetUserRoleErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/{id}/claims',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static usersServiceReinstateUser<ThrowOnError extends boolean = true>(options: Options<UsersServiceReinstateUserData, ThrowOnError>): RequestResult<UsersServiceReinstateUserResponses, UsersServiceReinstateUserErrors, ThrowOnError> {
        return (options.client ?? client).post<UsersServiceReinstateUserResponses, UsersServiceReinstateUserErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/{id}/reinstate',
            ...options
        });
    }
    
    public static usersServiceGetPartner<ThrowOnError extends boolean = true>(options: Options<UsersServiceGetPartnerData, ThrowOnError>): RequestResult<UsersServiceGetPartnerResponses, UsersServiceGetPartnerErrors, ThrowOnError> {
        return (options.client ?? client).get<UsersServiceGetPartnerResponses, UsersServiceGetPartnerErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/{id}/partner',
            ...options
        });
    }
}

export class ScheduleConfigService {
    public static scheduleConfigServiceGetAllHolidays<ThrowOnError extends boolean = true>(options?: Options<ScheduleConfigServiceGetAllHolidaysData, ThrowOnError>): RequestResult<ScheduleConfigServiceGetAllHolidaysResponses, ScheduleConfigServiceGetAllHolidaysErrors, ThrowOnError> {
        return (options?.client ?? client).get<ScheduleConfigServiceGetAllHolidaysResponses, ScheduleConfigServiceGetAllHolidaysErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/holidays/all',
            ...options
        });
    }
    
    public static scheduleConfigServiceGetHolidays<ThrowOnError extends boolean = true>(options: Options<ScheduleConfigServiceGetHolidaysData, ThrowOnError>): RequestResult<ScheduleConfigServiceGetHolidaysResponses, ScheduleConfigServiceGetHolidaysErrors, ThrowOnError> {
        return (options.client ?? client).get<ScheduleConfigServiceGetHolidaysResponses, ScheduleConfigServiceGetHolidaysErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/holidays/{year}',
            ...options
        });
    }
    
    public static scheduleConfigServiceCreateHoliday<ThrowOnError extends boolean = true>(options: Options<ScheduleConfigServiceCreateHolidayData, ThrowOnError>): RequestResult<ScheduleConfigServiceCreateHolidayResponses, ScheduleConfigServiceCreateHolidayErrors, ThrowOnError> {
        return (options.client ?? client).post<ScheduleConfigServiceCreateHolidayResponses, ScheduleConfigServiceCreateHolidayErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/holidays',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static scheduleConfigServiceDeleteHoliday<ThrowOnError extends boolean = true>(options: Options<ScheduleConfigServiceDeleteHolidayData, ThrowOnError>): RequestResult<ScheduleConfigServiceDeleteHolidayResponses, ScheduleConfigServiceDeleteHolidayErrors, ThrowOnError> {
        return (options.client ?? client).delete<ScheduleConfigServiceDeleteHolidayResponses, ScheduleConfigServiceDeleteHolidayErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/holidays/{id}',
            ...options
        });
    }
    
    public static scheduleConfigServiceUpdateHoliday<ThrowOnError extends boolean = true>(options: Options<ScheduleConfigServiceUpdateHolidayData, ThrowOnError>): RequestResult<ScheduleConfigServiceUpdateHolidayResponses, ScheduleConfigServiceUpdateHolidayErrors, ThrowOnError> {
        return (options.client ?? client).put<ScheduleConfigServiceUpdateHolidayResponses, ScheduleConfigServiceUpdateHolidayErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/holidays/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static scheduleConfigServiceGetHolidayShifts<ThrowOnError extends boolean = true>(options: Options<ScheduleConfigServiceGetHolidayShiftsData, ThrowOnError>): RequestResult<ScheduleConfigServiceGetHolidayShiftsResponses, ScheduleConfigServiceGetHolidayShiftsErrors, ThrowOnError> {
        return (options.client ?? client).get<ScheduleConfigServiceGetHolidayShiftsResponses, ScheduleConfigServiceGetHolidayShiftsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/holidays/{id}/shifts',
            ...options
        });
    }
    
    public static scheduleConfigServiceUpdateHolidayShifts<ThrowOnError extends boolean = true>(options: Options<ScheduleConfigServiceUpdateHolidayShiftsData, ThrowOnError>): RequestResult<ScheduleConfigServiceUpdateHolidayShiftsResponses, ScheduleConfigServiceUpdateHolidayShiftsErrors, ThrowOnError> {
        return (options.client ?? client).put<ScheduleConfigServiceUpdateHolidayShiftsResponses, ScheduleConfigServiceUpdateHolidayShiftsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/holidays/{id}/shifts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static scheduleConfigServiceGetShifts<ThrowOnError extends boolean = true>(options?: Options<ScheduleConfigServiceGetShiftsData, ThrowOnError>): RequestResult<ScheduleConfigServiceGetShiftsResponses, ScheduleConfigServiceGetShiftsErrors, ThrowOnError> {
        return (options?.client ?? client).get<ScheduleConfigServiceGetShiftsResponses, ScheduleConfigServiceGetShiftsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/shifts',
            ...options
        });
    }
    
    public static scheduleConfigServiceCreateShift<ThrowOnError extends boolean = true>(options: Options<ScheduleConfigServiceCreateShiftData, ThrowOnError>): RequestResult<ScheduleConfigServiceCreateShiftResponses, ScheduleConfigServiceCreateShiftErrors, ThrowOnError> {
        return (options.client ?? client).post<ScheduleConfigServiceCreateShiftResponses, ScheduleConfigServiceCreateShiftErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/shifts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static scheduleConfigServiceDeleteShift<ThrowOnError extends boolean = true>(options: Options<ScheduleConfigServiceDeleteShiftData, ThrowOnError>): RequestResult<ScheduleConfigServiceDeleteShiftResponses, ScheduleConfigServiceDeleteShiftErrors, ThrowOnError> {
        return (options.client ?? client).delete<ScheduleConfigServiceDeleteShiftResponses, ScheduleConfigServiceDeleteShiftErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/shifts/{shiftId}',
            ...options
        });
    }
    
    public static scheduleConfigServiceUpdateShift<ThrowOnError extends boolean = true>(options: Options<ScheduleConfigServiceUpdateShiftData, ThrowOnError>): RequestResult<ScheduleConfigServiceUpdateShiftResponses, ScheduleConfigServiceUpdateShiftErrors, ThrowOnError> {
        return (options.client ?? client).put<ScheduleConfigServiceUpdateShiftResponses, ScheduleConfigServiceUpdateShiftErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/shifts/{shiftId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static scheduleConfigServiceRerankShifts<ThrowOnError extends boolean = true>(options: Options<ScheduleConfigServiceRerankShiftsData, ThrowOnError>): RequestResult<ScheduleConfigServiceRerankShiftsResponses, ScheduleConfigServiceRerankShiftsErrors, ThrowOnError> {
        return (options.client ?? client).post<ScheduleConfigServiceRerankShiftsResponses, ScheduleConfigServiceRerankShiftsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/shifts/rerank',
            ...options
        });
    }
    
    public static scheduleConfigServiceGetVacationTypes<ThrowOnError extends boolean = true>(options?: Options<ScheduleConfigServiceGetVacationTypesData, ThrowOnError>): RequestResult<ScheduleConfigServiceGetVacationTypesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<ScheduleConfigServiceGetVacationTypesResponses, unknown, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/vacation-types',
            ...options
        });
    }
    
    public static scheduleConfigServiceGetVacationRequests<ThrowOnError extends boolean = true>(options?: Options<ScheduleConfigServiceGetVacationRequestsData, ThrowOnError>): RequestResult<ScheduleConfigServiceGetVacationRequestsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<ScheduleConfigServiceGetVacationRequestsResponses, unknown, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/requests',
            ...options
        });
    }
    
    public static scheduleConfigServiceCreateVacationRequest<ThrowOnError extends boolean = true>(options: Options<ScheduleConfigServiceCreateVacationRequestData, ThrowOnError>): RequestResult<ScheduleConfigServiceCreateVacationRequestResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<ScheduleConfigServiceCreateVacationRequestResponses, unknown, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/requests',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static scheduleConfigServiceGetVacationRequestsByPartner<ThrowOnError extends boolean = true>(options: Options<ScheduleConfigServiceGetVacationRequestsByPartnerData, ThrowOnError>): RequestResult<ScheduleConfigServiceGetVacationRequestsByPartnerResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<ScheduleConfigServiceGetVacationRequestsByPartnerResponses, unknown, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/requests/partner/{partnerId}',
            ...options
        });
    }
    
    public static scheduleConfigServiceDeleteVacationRequest<ThrowOnError extends boolean = true>(options: Options<ScheduleConfigServiceDeleteVacationRequestData, ThrowOnError>): RequestResult<ScheduleConfigServiceDeleteVacationRequestResponses, ScheduleConfigServiceDeleteVacationRequestErrors, ThrowOnError> {
        return (options.client ?? client).delete<ScheduleConfigServiceDeleteVacationRequestResponses, ScheduleConfigServiceDeleteVacationRequestErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/requests/{requestId}',
            ...options
        });
    }
    
    public static scheduleConfigServiceApproveVacationRequest<ThrowOnError extends boolean = true>(options: Options<ScheduleConfigServiceApproveVacationRequestData, ThrowOnError>): RequestResult<ScheduleConfigServiceApproveVacationRequestResponses, ScheduleConfigServiceApproveVacationRequestErrors, ThrowOnError> {
        return (options.client ?? client).post<ScheduleConfigServiceApproveVacationRequestResponses, ScheduleConfigServiceApproveVacationRequestErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/requests/{requestId}/approve',
            ...options
        });
    }
    
    public static scheduleConfigServiceDenyVacationRequest<ThrowOnError extends boolean = true>(options: Options<ScheduleConfigServiceDenyVacationRequestData, ThrowOnError>): RequestResult<ScheduleConfigServiceDenyVacationRequestResponses, ScheduleConfigServiceDenyVacationRequestErrors, ThrowOnError> {
        return (options.client ?? client).post<ScheduleConfigServiceDenyVacationRequestResponses, ScheduleConfigServiceDenyVacationRequestErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/config/requests/{requestId}/deny',
            ...options
        });
    }
}

export class ScheduleService {
    public static scheduleServiceGetSchedule<ThrowOnError extends boolean = true>(options: Options<ScheduleServiceGetScheduleData, ThrowOnError>): RequestResult<ScheduleServiceGetScheduleResponses, ScheduleServiceGetScheduleErrors, ThrowOnError> {
        return (options.client ?? client).get<ScheduleServiceGetScheduleResponses, ScheduleServiceGetScheduleErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule',
            ...options
        });
    }
    
    public static scheduleServiceGetLimitedSchedule<ThrowOnError extends boolean = true>(options: Options<ScheduleServiceGetLimitedScheduleData, ThrowOnError>): RequestResult<ScheduleServiceGetLimitedScheduleResponses, ScheduleServiceGetLimitedScheduleErrors, ThrowOnError> {
        return (options.client ?? client).get<ScheduleServiceGetLimitedScheduleResponses, ScheduleServiceGetLimitedScheduleErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/limited',
            ...options
        });
    }
    
    public static scheduleServiceGetPartnerSchedule<ThrowOnError extends boolean = true>(options: Options<ScheduleServiceGetPartnerScheduleData, ThrowOnError>): RequestResult<ScheduleServiceGetPartnerScheduleResponses, ScheduleServiceGetPartnerScheduleErrors, ThrowOnError> {
        return (options.client ?? client).get<ScheduleServiceGetPartnerScheduleResponses, ScheduleServiceGetPartnerScheduleErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/partner/{partnerId}',
            ...options
        });
    }
    
    public static scheduleServiceDownloadPartnerSchedule<ThrowOnError extends boolean = true>(options: Options<ScheduleServiceDownloadPartnerScheduleData, ThrowOnError>): RequestResult<ScheduleServiceDownloadPartnerScheduleResponses, ScheduleServiceDownloadPartnerScheduleErrors, ThrowOnError> {
        return (options.client ?? client).get<ScheduleServiceDownloadPartnerScheduleResponses, ScheduleServiceDownloadPartnerScheduleErrors, ThrowOnError>({ url: '/schedule/partner/{partner}/ical', ...options });
    }
    
    public static scheduleServiceCreateSchedule<ThrowOnError extends boolean = true>(options: Options<ScheduleServiceCreateScheduleData, ThrowOnError>): RequestResult<ScheduleServiceCreateScheduleResponses, ScheduleServiceCreateScheduleErrors, ThrowOnError> {
        return (options.client ?? client).post<ScheduleServiceCreateScheduleResponses, ScheduleServiceCreateScheduleErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/create',
            ...options
        });
    }
    
    public static scheduleServiceCreateAssignment<ThrowOnError extends boolean = true>(options: Options<ScheduleServiceCreateAssignmentData, ThrowOnError>): RequestResult<ScheduleServiceCreateAssignmentResponses, ScheduleServiceCreateAssignmentErrors, ThrowOnError> {
        return (options.client ?? client).post<ScheduleServiceCreateAssignmentResponses, ScheduleServiceCreateAssignmentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/create/assignment',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static scheduleServiceUpdateUnpublishedSchedule<ThrowOnError extends boolean = true>(options: Options<ScheduleServiceUpdateUnpublishedScheduleData, ThrowOnError>): RequestResult<ScheduleServiceUpdateUnpublishedScheduleResponses, ScheduleServiceUpdateUnpublishedScheduleErrors, ThrowOnError> {
        return (options.client ?? client).patch<ScheduleServiceUpdateUnpublishedScheduleResponses, ScheduleServiceUpdateUnpublishedScheduleErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/unpublished',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static scheduleServicePublishSchedule<ThrowOnError extends boolean = true>(options: Options<ScheduleServicePublishScheduleData, ThrowOnError>): RequestResult<ScheduleServicePublishScheduleResponses, ScheduleServicePublishScheduleErrors, ThrowOnError> {
        return (options.client ?? client).post<ScheduleServicePublishScheduleResponses, ScheduleServicePublishScheduleErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/publish',
            ...options
        });
    }
    
    public static scheduleServiceGetPublishDate<ThrowOnError extends boolean = true>(options: Options<ScheduleServiceGetPublishDateData, ThrowOnError>): RequestResult<ScheduleServiceGetPublishDateResponses, ScheduleServiceGetPublishDateErrors, ThrowOnError> {
        return (options.client ?? client).get<ScheduleServiceGetPublishDateResponses, ScheduleServiceGetPublishDateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/publish/date',
            ...options
        });
    }
    
    public static scheduleServiceUpdateScheduleAsWorked<ThrowOnError extends boolean = true>(options: Options<ScheduleServiceUpdateScheduleAsWorkedData, ThrowOnError>): RequestResult<ScheduleServiceUpdateScheduleAsWorkedResponses, ScheduleServiceUpdateScheduleAsWorkedErrors, ThrowOnError> {
        return (options.client ?? client).patch<ScheduleServiceUpdateScheduleAsWorkedResponses, ScheduleServiceUpdateScheduleAsWorkedErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/schedule/updateAsWorked',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class ReportsService {
    public static reportsServiceGetCompPointsReport<ThrowOnError extends boolean = true>(options: Options<ReportsServiceGetCompPointsReportData, ThrowOnError>): RequestResult<ReportsServiceGetCompPointsReportResponses, ReportsServiceGetCompPointsReportErrors, ThrowOnError> {
        return (options.client ?? client).get<ReportsServiceGetCompPointsReportResponses, ReportsServiceGetCompPointsReportErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/reports/comp-points/{year}',
            ...options
        });
    }
    
    public static reportsServiceGetShiftTotalsConfig<ThrowOnError extends boolean = true>(options?: Options<ReportsServiceGetShiftTotalsConfigData, ThrowOnError>): RequestResult<ReportsServiceGetShiftTotalsConfigResponses, ReportsServiceGetShiftTotalsConfigErrors, ThrowOnError> {
        return (options?.client ?? client).get<ReportsServiceGetShiftTotalsConfigResponses, ReportsServiceGetShiftTotalsConfigErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/reports/shifts/config',
            ...options
        });
    }
    
    public static reportsServiceUpdateShiftTotalsConfig<ThrowOnError extends boolean = true>(options: Options<ReportsServiceUpdateShiftTotalsConfigData, ThrowOnError>): RequestResult<ReportsServiceUpdateShiftTotalsConfigResponses, ReportsServiceUpdateShiftTotalsConfigErrors, ThrowOnError> {
        return (options.client ?? client).put<ReportsServiceUpdateShiftTotalsConfigResponses, ReportsServiceUpdateShiftTotalsConfigErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/reports/shifts/config',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static reportsServiceGetShiftTotalsReport<ThrowOnError extends boolean = true>(options: Options<ReportsServiceGetShiftTotalsReportData, ThrowOnError>): RequestResult<ReportsServiceGetShiftTotalsReportResponses, ReportsServiceGetShiftTotalsReportErrors, ThrowOnError> {
        return (options.client ?? client).get<ReportsServiceGetShiftTotalsReportResponses, ReportsServiceGetShiftTotalsReportErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/reports/shifts/{year}',
            ...options
        });
    }
}

export class PartnersService {
    public static partnersServiceGetPartners<ThrowOnError extends boolean = true>(options?: Options<PartnersServiceGetPartnersData, ThrowOnError>): RequestResult<PartnersServiceGetPartnersResponses, PartnersServiceGetPartnersErrors, ThrowOnError> {
        return (options?.client ?? client).get<PartnersServiceGetPartnersResponses, PartnersServiceGetPartnersErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/partners',
            ...options
        });
    }
    
    public static partnersServiceCreatePartner<ThrowOnError extends boolean = true>(options: Options<PartnersServiceCreatePartnerData, ThrowOnError>): RequestResult<PartnersServiceCreatePartnerResponses, PartnersServiceCreatePartnerErrors, ThrowOnError> {
        return (options.client ?? client).post<PartnersServiceCreatePartnerResponses, PartnersServiceCreatePartnerErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/partners',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static partnersServiceRemovePartner<ThrowOnError extends boolean = true>(options: Options<PartnersServiceRemovePartnerData, ThrowOnError>): RequestResult<PartnersServiceRemovePartnerResponses, PartnersServiceRemovePartnerErrors, ThrowOnError> {
        return (options.client ?? client).delete<PartnersServiceRemovePartnerResponses, PartnersServiceRemovePartnerErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/partners/{id}',
            ...options
        });
    }
    
    public static partnersServiceGetPartner<ThrowOnError extends boolean = true>(options: Options<PartnersServiceGetPartnerData, ThrowOnError>): RequestResult<PartnersServiceGetPartnerResponses, PartnersServiceGetPartnerErrors, ThrowOnError> {
        return (options.client ?? client).get<PartnersServiceGetPartnerResponses, PartnersServiceGetPartnerErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/partners/{id}',
            ...options
        });
    }
    
    public static partnersServiceUpdatePartner<ThrowOnError extends boolean = true>(options: Options<PartnersServiceUpdatePartnerData, ThrowOnError>): RequestResult<PartnersServiceUpdatePartnerResponses, PartnersServiceUpdatePartnerErrors, ThrowOnError> {
        return (options.client ?? client).put<PartnersServiceUpdatePartnerResponses, PartnersServiceUpdatePartnerErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/partners/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class DocumentsService {
    public static documentsServiceGetDocuments<ThrowOnError extends boolean = true>(options?: Options<DocumentsServiceGetDocumentsData, ThrowOnError>): RequestResult<DocumentsServiceGetDocumentsResponses, DocumentsServiceGetDocumentsErrors, ThrowOnError> {
        return (options?.client ?? client).get<DocumentsServiceGetDocumentsResponses, DocumentsServiceGetDocumentsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/documents',
            ...options
        });
    }
    
    public static documentsServiceDeleteDocument<ThrowOnError extends boolean = true>(options: Options<DocumentsServiceDeleteDocumentData, ThrowOnError>): RequestResult<DocumentsServiceDeleteDocumentResponses, DocumentsServiceDeleteDocumentErrors, ThrowOnError> {
        return (options.client ?? client).post<DocumentsServiceDeleteDocumentResponses, DocumentsServiceDeleteDocumentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/documents',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static documentsServiceGetDocumentMetadata<ThrowOnError extends boolean = true>(options?: Options<DocumentsServiceGetDocumentMetadataData, ThrowOnError>): RequestResult<DocumentsServiceGetDocumentMetadataResponses, DocumentsServiceGetDocumentMetadataErrors, ThrowOnError> {
        return (options?.client ?? client).get<DocumentsServiceGetDocumentMetadataResponses, DocumentsServiceGetDocumentMetadataErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/documents/metadata',
            ...options
        });
    }
    
    public static documentsServiceDownloadDocument<ThrowOnError extends boolean = true>(options: Options<DocumentsServiceDownloadDocumentData, ThrowOnError>): RequestResult<DocumentsServiceDownloadDocumentResponses, DocumentsServiceDownloadDocumentErrors, ThrowOnError> {
        return (options.client ?? client).post<DocumentsServiceDownloadDocumentResponses, DocumentsServiceDownloadDocumentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/documents/download',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static documentsServiceUploadDocument<ThrowOnError extends boolean = true>(options: Options<DocumentsServiceUploadDocumentData, ThrowOnError>): RequestResult<DocumentsServiceUploadDocumentResponses, DocumentsServiceUploadDocumentErrors, ThrowOnError> {
        return (options.client ?? client).post<DocumentsServiceUploadDocumentResponses, DocumentsServiceUploadDocumentErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/documents/upload',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    public static documentsServiceGetDocumentLinks<ThrowOnError extends boolean = true>(options?: Options<DocumentsServiceGetDocumentLinksData, ThrowOnError>): RequestResult<DocumentsServiceGetDocumentLinksResponses, DocumentsServiceGetDocumentLinksErrors, ThrowOnError> {
        return (options?.client ?? client).get<DocumentsServiceGetDocumentLinksResponses, DocumentsServiceGetDocumentLinksErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/documents/links',
            ...options
        });
    }
    
    public static documentsServiceCreateDocumentLink<ThrowOnError extends boolean = true>(options: Options<DocumentsServiceCreateDocumentLinkData, ThrowOnError>): RequestResult<DocumentsServiceCreateDocumentLinkResponses, DocumentsServiceCreateDocumentLinkErrors, ThrowOnError> {
        return (options.client ?? client).post<DocumentsServiceCreateDocumentLinkResponses, DocumentsServiceCreateDocumentLinkErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/documents/links',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static documentsServiceDeleteDocumentLink<ThrowOnError extends boolean = true>(options: Options<DocumentsServiceDeleteDocumentLinkData, ThrowOnError>): RequestResult<DocumentsServiceDeleteDocumentLinkResponses, DocumentsServiceDeleteDocumentLinkErrors, ThrowOnError> {
        return (options.client ?? client).delete<DocumentsServiceDeleteDocumentLinkResponses, DocumentsServiceDeleteDocumentLinkErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/documents/links/{id}',
            ...options
        });
    }
    
    public static documentsServiceGetDocumentLink<ThrowOnError extends boolean = true>(options: Options<DocumentsServiceGetDocumentLinkData, ThrowOnError>): RequestResult<DocumentsServiceGetDocumentLinkResponses, DocumentsServiceGetDocumentLinkErrors, ThrowOnError> {
        return (options.client ?? client).get<DocumentsServiceGetDocumentLinkResponses, DocumentsServiceGetDocumentLinkErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/documents/links/{id}',
            ...options
        });
    }
    
    public static documentsServiceUpdateDocumentLink<ThrowOnError extends boolean = true>(options: Options<DocumentsServiceUpdateDocumentLinkData, ThrowOnError>): RequestResult<DocumentsServiceUpdateDocumentLinkResponses, DocumentsServiceUpdateDocumentLinkErrors, ThrowOnError> {
        return (options.client ?? client).patch<DocumentsServiceUpdateDocumentLinkResponses, DocumentsServiceUpdateDocumentLinkErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/documents/links/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
